import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Ship, AlertTriangle } from "lucide-react";

const fmt = (d) => (d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "—");
const fmtTs = (d) => (d ? new Date(d).toLocaleString() : "never");
const STAGE = { FACTORY_DISPATCHED: "Left factory", AT_PORT_CASABLANCA: "At Casablanca port", VESSEL_DEPARTED: "On the water", AT_PORT_MIAMI: "At Miami port" };

export const ShipmentTrackingCard = () => {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    const run = async () => {
      try { await api.post("/container-tracking/sync-due"); } catch { /* page open must not fail on carrier */ }
      try { const r = await api.get("/container-tracking/overview"); if (alive) setRows(r.data); } catch { if (alive) setRows([]); }
    };
    run();
    return () => { alive = false; };
  }, []);

  if (!rows || rows.length === 0) return null;
  return (
    <Card className="border-border bg-white" data-testid="dashboard-shipment-tracking">
      <CardContent className="p-5">
        <div className="mb-3 flex items-center gap-2"><Ship className="h-4 w-4 text-terracotta" /><h2 className="text-base font-medium text-charcoal md:text-lg">Shipment tracking</h2></div>
        <div className="divide-y divide-border">
          {rows.map((r) => (
            <button key={r.container_id} onClick={() => navigate(`/admin/containers/${r.container_id}`)} className="flex w-full flex-wrap items-center justify-between gap-2 py-2.5 text-left hover:bg-sand/50" data-testid={`dash-ship-${r.zc_ref}`}>
              <div className="min-w-[200px]">
                <p className="text-sm font-semibold text-charcoal">{r.zc_ref} <span className="font-mono text-[11px] font-normal text-warmgrey">{r.shipping_number || "no container no."}{r.bill_of_lading ? ` · B/L ${r.bill_of_lading}` : ""}</span></p>
                <p className="text-xs text-warmgrey">{r.status === "IN_MOROCCO" ? "In Morocco" : STAGE[r.transit_stage] || r.status}{r.transit_stage && r.stage_dates?.[r.transit_stage] ? ` · ${fmt(r.stage_dates[r.transit_stage])}` : ""}{r.vessel ? ` · ${r.vessel}` : ""}</p>
              </div>
              <div className="text-right text-xs text-warmgrey">
                <p>Carrier ETA {fmt(r.carrier_eta)} · Warehouse ETA {fmt(r.eta_warehouse)}</p>
                <p className={r.error || r.review_required ? "text-amber-700" : ""} data-testid={`dash-ship-status-${r.zc_ref}`}>
                  {(r.error || r.review_required) && <AlertTriangle className="mr-1 inline h-3 w-3" />}
                  {r.trackable ? `${(r.tracking_status || "never checked").replace(/_/g, " ").toLowerCase()} · checked ${fmtTs(r.last_checked_at)}` : r.trackable_reason}
                </p>
              </div>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
